var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneralFacultystudentratio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 39.021,
    viewBox: "0 0 41 39.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(-1 -2.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48169",
    "data-name": "Group 48169",
    transform: "translate(15.548 7.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55388",
    "data-name": "Path 55388",
    d: "M23.661,15.56A.661.661,0,0,1,23,14.9V10.491a.661.661,0,0,1,1.323,0V14.9A.661.661,0,0,1,23.661,15.56Z",
    transform: "translate(-23 -9.83)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48170",
    "data-name": "Group 48170",
    transform: "translate(26.13 7.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55389",
    "data-name": "Path 55389",
    d: "M39.662,15.56A.661.661,0,0,1,39,14.9V10.491a.661.661,0,0,1,1.323,0V14.9A.661.661,0,0,1,39.662,15.56Z",
    transform: "translate(-39.001 -9.83)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48171",
    "data-name": "Group 48171",
    transform: "translate(15.548 11.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55390",
    "data-name": "Path 55390",
    d: "M24.984,19.14A1.986,1.986,0,0,1,23,17.156a.661.661,0,1,1,1.323,0,.662.662,0,0,0,.661.661.661.661,0,0,1,0,1.323Z",
    transform: "translate(-23 -16.495)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48172",
    "data-name": "Group 48172",
    transform: "translate(24.806 11.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55391",
    "data-name": "Path 55391",
    d: "M37.661,19.141a.661.661,0,0,1,0-1.323.663.663,0,0,0,.662-.662.661.661,0,1,1,1.323,0A1.987,1.987,0,0,1,37.661,19.141Z",
    transform: "translate(-37 -16.495)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48173",
    "data-name": "Group 48173",
    transform: "translate(16.871 13.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55392",
    "data-name": "Path 55392",
    d: "M33.6,19.818H25.661a.661.661,0,0,1,0-1.323H33.6a.661.661,0,0,1,0,1.323Z",
    transform: "translate(-25 -18.495)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48174",
    "data-name": "Group 48174",
    transform: "translate(1 3.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55393",
    "data-name": "Path 55393",
    d: "M52.29,30.481a5.283,5.283,0,0,1,3.968,1.792v.2a4.609,4.609,0,0,1-2.652,4.173,4.586,4.586,0,0,1-3.961,0A4.612,4.612,0,0,1,47,32.471v-1.99A1.985,1.985,0,0,0,48.984,28.5a1.981,1.981,0,0,0,1.984,1.984Z",
    transform: "translate(-16.581 -11.964)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55394",
    "data-name": "Path 55394",
    d: "M15.645,28.279v.905C14.507,27.7,13.82,27.433,13,27.6V27.6l1.323-2.691A4.95,4.95,0,0,1,15.645,28.279Z",
    transform: "translate(-5.065 -10.748)",
    fill: "#c5e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55395",
    "data-name": "Path 55395",
    d: "M10.6,24.094,9.274,26.785v.007c-1.244.251-2.77,1.541-6.613,1.09-.212-.026-.43-.053-.661-.092v-.324a4.96,4.96,0,0,1,8.6-3.372Z",
    transform: "translate(-1.339 -9.935)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55396",
    "data-name": "Path 55396",
    d: "M12.258,32.607v.007a4.609,4.609,0,0,1-2.652,4.173,4.587,4.587,0,0,1-3.961,0A4.612,4.612,0,0,1,3,32.614V30.053c3.843.451,5.369-.84,6.613-1.09.82-.172,1.507.1,2.645,1.58Z",
    transform: "translate(-1.677 -12.107)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55397",
    "data-name": "Path 55397",
    d: "M12.134,28.956v3.671A4.607,4.607,0,0,1,9.483,36.8a4.534,4.534,0,0,1-.987.341,4.658,4.658,0,0,0,.995.109,4.518,4.518,0,0,0,1.977-.45,4.608,4.608,0,0,0,2.652-4.173V30.556c-.824-1.074-1.412-1.506-1.985-1.6Z",
    transform: "translate(-3.539 -12.12)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55398",
    "data-name": "Path 55398",
    d: "M56.138,28.956v3.671A4.607,4.607,0,0,1,53.487,36.8a4.534,4.534,0,0,1-.987.341,4.658,4.658,0,0,0,.995.109,4.518,4.518,0,0,0,1.977-.45,4.608,4.608,0,0,0,2.652-4.173V30.556c-.824-1.074-1.412-1.506-1.985-1.6Z",
    transform: "translate(-18.444 -12.12)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55399",
    "data-name": "Path 55399",
    d: "M33.29,48.573V50.51l-1.323,1.323-1.323-.661-1.323.661L28,50.51V48.573a6,6,0,0,0,2.639.615,5.935,5.935,0,0,0,2.645-.621Z",
    transform: "translate(-10.145 -18.762)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55400",
    "data-name": "Path 55400",
    d: "M25.29,51.505l2.645,6.613H20.661A.659.659,0,0,1,20,57.457V54.811a3.3,3.3,0,0,1,3.306-3.306Z",
    transform: "translate(-7.435 -19.757)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55401",
    "data-name": "Path 55401",
    d: "M15.955,45.49v2.645H10.01l1.977-4.629h1.984A1.985,1.985,0,0,1,15.955,45.49Z",
    transform: "translate(-4.052 -17.048)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55402",
    "data-name": "Path 55402",
    d: "M14.984,43.506H13a1.986,1.986,0,0,1,1.983,1.984v2.645h1.985V45.49A1.985,1.985,0,0,0,14.984,43.506Z",
    transform: "translate(-5.065 -17.048)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55403",
    "data-name": "Path 55403",
    d: "M31.968,52.828l1.323-1.323-2.645,6.613L28,51.505l1.323,1.323,1.323-.661Z",
    transform: "translate(-10.145 -19.757)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55404",
    "data-name": "Path 55404",
    d: "M34.581,10.826v4.411a1.322,1.322,0,0,1-1.323,1.323H25.323A1.318,1.318,0,0,1,24,15.237V10.826l5.29,1.766Z",
    transform: "translate(-8.79 -5.979)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55405",
    "data-name": "Path 55405",
    d: "M39.935,54.811v2.645a.663.663,0,0,1-.661.661H32l2.645-6.613h1.984A3.308,3.308,0,0,1,39.935,54.811Z",
    transform: "translate(-11.5 -19.757)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55406",
    "data-name": "Path 55406",
    d: "M37.984,51.505H36a3.308,3.308,0,0,1,3.305,3.306v2.645a.663.663,0,0,1-.661.661h1.985a.663.663,0,0,0,.661-.661V54.811A3.308,3.308,0,0,0,37.984,51.505Z",
    transform: "translate(-12.855 -19.757)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55407",
    "data-name": "Path 55407",
    d: "M36.839,6.8,32.21,8.343l-5.29,1.766-5.29-1.766L17,6.8,26.919,3.5Z",
    transform: "translate(-6.419 -3.496)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55408",
    "data-name": "Path 55408",
    d: "M48.984,23.5V26.8A1.985,1.985,0,0,1,47,28.787V25.481A1.981,1.981,0,0,1,48.984,23.5Z",
    transform: "translate(-16.581 -10.271)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55409",
    "data-name": "Path 55409",
    d: "M34.9,36.841v1.97a5.962,5.962,0,0,1-5.958,5.952A5.938,5.938,0,0,1,23,38.844v-2L24.984,35.5a15.216,15.216,0,0,0,4.3.661,8.811,8.811,0,0,0,3.637-.661Z",
    transform: "translate(-8.452 -14.337)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55410",
    "data-name": "Path 55410",
    d: "M35.456,35.506h0v3.306a5.924,5.924,0,0,1-4.965,5.859,5.943,5.943,0,0,0,6.95-5.858v-1.97Z",
    transform: "translate(-10.989 -14.338)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55411",
    "data-name": "Path 55411",
    d: "M54.968,43.506,52.99,48.135h-.013L51,43.506l.661.661,1.323-.661,1.323.661Z",
    transform: "translate(-17.935 -17.048)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55412",
    "data-name": "Path 55412",
    d: "M52.984,41.267a4.518,4.518,0,0,0,1.977-.45l.007.007V42.6l-.661.661L52.984,42.6l-1.323.661L51,42.6V40.817A4.547,4.547,0,0,0,52.984,41.267Z",
    transform: "translate(-17.935 -16.137)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55413",
    "data-name": "Path 55413",
    d: "M58.6,26.787V33.4a5.292,5.292,0,0,0-5.29-5.29H51.984A1.981,1.981,0,0,1,50,26.126V22.82A5.4,5.4,0,0,1,53.306,21.5,5.293,5.293,0,0,1,58.6,26.787Z",
    transform: "translate(-17.597 -9.593)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55414",
    "data-name": "Path 55414",
    d: "M54.525,21.5a4.18,4.18,0,0,0-.926.106,5.3,5.3,0,0,1,4.232,5.185v2.492a5.413,5.413,0,0,1,.663.623,5.281,5.281,0,0,1,1.323,3.5V26.787a5.293,5.293,0,0,0-5.29-5.29Z",
    transform: "translate(-18.816 -9.593)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55415",
    "data-name": "Path 55415",
    d: "M59.955,45.49v2.645H54.01l1.977-4.629h1.984A1.985,1.985,0,0,1,59.955,45.49Z",
    transform: "translate(-18.955 -17.048)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55416",
    "data-name": "Path 55416",
    d: "M58.984,43.506H57a1.986,1.986,0,0,1,1.983,1.984v2.645h1.985V45.49A1.985,1.985,0,0,0,58.984,43.506Z",
    transform: "translate(-19.968 -17.048)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55417",
    "data-name": "Path 55417",
    d: "M45.01,45.49v2.645h5.945l-1.977-4.629H46.994A1.985,1.985,0,0,0,45.01,45.49Z",
    transform: "translate(-15.907 -17.048)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55418",
    "data-name": "Path 55418",
    d: "M10.968,40.824V42.6l-.661.661L8.984,42.6l-1.323.661L7,42.6V40.817a4.586,4.586,0,0,0,3.961,0Z",
    transform: "translate(-3.032 -16.137)",
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55419",
    "data-name": "Path 55419",
    d: "M10.306,44.167l.661-.661L8.99,48.135H8.977L7,43.506l.661.661,1.323-.661Z",
    transform: "translate(-3.032 -17.048)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55420",
    "data-name": "Path 55420",
    d: "M4.968,43.506l1.977,4.629H1V45.49a1.981,1.981,0,0,1,1.984-1.984Z",
    transform: "translate(-1 -17.048)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55421",
    "data-name": "Path 55421",
    d: "M24.984,32.458,23,33.794v-2a5.28,5.28,0,0,1,5.29-5.29h3.968v2.645A2.64,2.64,0,0,1,34.9,31.8v2l-1.984-1.336a8.811,8.811,0,0,1-3.637.661A15.216,15.216,0,0,1,24.984,32.458Z",
    transform: "translate(-8.452 -11.29)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55422",
    "data-name": "Path 55422",
    d: "M38.629,33.793v-2a2.64,2.64,0,0,0-2.645-2.645V26.505H34V29.15a1.984,1.984,0,0,0,1.984,1.984.654.654,0,0,1,.661.661v.661Z",
    transform: "translate(-12.177 -11.289)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48175",
    "data-name": "Group 48175",
    transform: "translate(10.919 2.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55423",
    "data-name": "Path 55423",
    d: "M26.581,10.432a.647.647,0,0,1-.209-.034L16.452,7.091a.661.661,0,0,1,0-1.254l9.919-3.306a.666.666,0,0,1,.419,0L36.71,5.837a.661.661,0,0,1,0,1.254L26.79,10.4A.647.647,0,0,1,26.581,10.432ZM18.752,6.464l7.828,2.609,7.828-2.609L26.581,3.855Z",
    transform: "translate(-16 -2.497)",
    fill: "#63c5b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48176",
    "data-name": "Group 48176",
    transform: "translate(30.758 5.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55424",
    "data-name": "Path 55424",
    d: "M46.661,12.786A.661.661,0,0,1,46,12.124V8.157a.661.661,0,1,1,1.323,0v3.967A.661.661,0,0,1,46.661,12.786Z",
    transform: "translate(-46 -7.496)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48177",
    "data-name": "Group 48177",
    transform: "translate(20.839 5.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55425",
    "data-name": "Path 55425",
    d: "M41.581,8.818H31.661a.661.661,0,0,1,0-1.323h9.919a.661.661,0,1,1,0,1.323Z",
    transform: "translate(-31 -7.495)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralFacultystudentratio);
export default __webpack_public_path__ + "static/media/university-general-facultystudentratio.affc438b31717fe06b4c86e8f44be469.svg";
export { ForwardRef as ReactComponent };